import React from "react";
import AddIcon from "@mui/icons-material/Add";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import Popup from "src/components/popup/Popup";
import WardForm from "../Form/WardForm/WardForm";

const WardPopup = ({
  openPopup,
  setOpenPopup,
  recordForEdit,
  addOrEdit,
  handleOpenPopup,
  provinceId,
}) => {
  return (
    <>
      <Controls.Button
        text="Add New"
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={() => {
          handleOpenPopup(isOpenPopup, null);
        }}
      />

      <Popup
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              marginTop: "-10%",
              width: "100%",
              maxWidth: "500px", // Set your width here
            },
          },
        }}
        title={!recordForEdit ? "Create Ward" : "Edit Ward"}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <WardForm
          addOrEdit={addOrEdit}
          provinceId={provinceId}
          recordForEdit={recordForEdit}
        />
      </Popup>
    </>
  );
};

export default WardPopup;
